import { array } from "@ember/helper";
import { LinkTo } from "@ember/routing";
import ageWithTooltip from "discourse/helpers/age-with-tooltip";
import { i18n } from "discourse-i18n";

export default <template>
  <section class="user-content">
    <table class="group-reports">
      <thead>
        <th>
          {{i18n "explorer.report_name"}}
        </th>
        <th>
          {{i18n "explorer.query_description"}}
        </th>
        <th>
          {{i18n "explorer.query_time"}}
        </th>
      </thead>
      <tbody>
        {{#each @controller.model.queries as |query|}}
          <tr>
            <td>
              <LinkTo
                @route="group.reports.show"
                @models={{array @controller.group.name query.id}}
              >
                {{query.name}}
              </LinkTo>
            </td>
            <td>{{query.description}}</td>
            <td>
              {{#if query.last_run_at}}
                {{ageWithTooltip query.last_run_at format="medium"}}
              {{/if}}
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </section>
</template>
